// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3CMIr"};